export const REWARD_TYPES = {
  BONUS_PRODUCTS: 'BONUS_PRODUCTS',
  PRODUCT: 'PRODUCT',
  PEP_VOUCHER_PRODUCT: 'PEP_VOUCHER_PRODUCT',
  PEP_VOUCHER_DISCOUNT: 'PEP_VOUCHER_DISCOUNT',
  VISA_CARD: 'VISA_CARD',
  PHYSICAL: 'PHYSICAL',
  CASH: 'CASH',
  DISCOUNT: 'DISCOUNT',
  DIGITAL: 'DIGITAL',
  DIGITAL_PRE_ORDER: 'DIGITAL_PRE_ORDER',
  LOYALTY: 'LOYALTY'
};

export const REWARD_TYPES_DISPLAY = {
  BONUS_PRODUCTS: 'Bonus Products',
  PRODUCT: 'Product',
  PEP_VOUCHER_PRODUCT: 'PepVoucher - Product',
  PEP_VOUCHER_DISCOUNT: 'PepVoucher - Discount',
  VISA_CARD: 'Visa Card',
  PHYSICAL: 'Physical',
  CASH: 'Cash',
  DISCOUNT: 'Discount',
  DIGITAL: 'Digital',
  DIGITAL_PRE_ORDER: 'Digital Pre-Order',
  LOYALTY: 'Loyalty'
};

// Reward types that use per-product display (images, rewardText per product)
export const PRODUCT_BASED_REWARD_TYPES = [
  REWARD_TYPES.BONUS_PRODUCTS,
  REWARD_TYPES.PRODUCT,
  REWARD_TYPES.PEP_VOUCHER_PRODUCT
];

// Single image upload reward types list
export const SINGLE_IMAGE_REWARD_TYPES = [
  REWARD_TYPES.CASH,
  REWARD_TYPES.DISCOUNT,
  REWARD_TYPES.PHYSICAL,
  REWARD_TYPES.VISA_CARD,
  REWARD_TYPES.DIGITAL,
  REWARD_TYPES.DIGITAL_PRE_ORDER,
  REWARD_TYPES.LOYALTY,
  REWARD_TYPES.PEP_VOUCHER_DISCOUNT
];

export const INVENTORY_MANAGED_REWARD_TYPES = [
  REWARD_TYPES.CASH,
  REWARD_TYPES.PRODUCT,
  REWARD_TYPES.PHYSICAL,
  REWARD_TYPES.DIGITAL,
  REWARD_TYPES.DIGITAL_PRE_ORDER,
  REWARD_TYPES.LOYALTY,
  REWARD_TYPES.PEP_VOUCHER_DISCOUNT,
  REWARD_TYPES.DISCOUNT,
  REWARD_TYPES.PEP_VOUCHER_PRODUCT
];

export const isInventoryManagedRewardType = (rewardType, cardType) => {
  if (!rewardType) return false;

  if (INVENTORY_MANAGED_REWARD_TYPES.includes(rewardType)) return true;

  if (rewardType === REWARD_TYPES.VISA_CARD) {
    return cardType !== REWARD_CARD_TYPES.Both;
  }

  return false;
};

export const REWARD_CARD_TYPES = {
  Physical: 'Physical',
  Digital: 'Digital',
  Both: 'Both'
};

export const REWARD_STATUS = {
  DRAFT: 'DRAFT',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED',
  ACTIVE: 'ACTIVE',
  PUBLISHED: 'PUBLISHED'
};

export const DISABLE_SAVE_DRAFT_REWARD_STATUS = [
  REWARD_STATUS.EXPIRED,
  REWARD_STATUS.REVOKED,
  REWARD_STATUS.PUBLISHED,
  REWARD_STATUS.ACTIVE
];

export const DISABLE_EDIT_REWARD_STATUS = [
  REWARD_STATUS.EXPIRED,
  REWARD_STATUS.REVOKED
];

export const DISABLE_PUBLISH_REWARD_STATUS = [
  REWARD_STATUS.EXPIRED,
  REWARD_STATUS.REVOKED
];

export const REVOKE_BUTTON_VISIBLE_STATUS = [
  REWARD_STATUS.PUBLISHED,
  REWARD_STATUS.ACTIVE
];

export const REVOKE_BUTTON_DISABLED_STATUS = [
  REWARD_STATUS.EXPIRED,
  REWARD_STATUS.DRAFT,
  REWARD_STATUS.REVOKED
];

export const DUPLICATE_BUTTON_ENABLED_STATUS = [
  REWARD_STATUS.PUBLISHED,
  REWARD_STATUS.ACTIVE,
  REWARD_STATUS.EXPIRED,
  REWARD_STATUS.REVOKED
];
